"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _faSync = require("@fortawesome/free-solid-svg-icons/faSync");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var Status = _interopRequireWildcard(require("chaire-lib-common/lib/utils/Status"));
var _LodashExtensions = require("chaire-lib-common/lib/utils/LodashExtensions");
var _pages = require("chaire-lib-frontend/lib/components/pages");
var _ServiceLocator = _interopRequireDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
var _localStorageManager = require("../../../services/ui/localStorageManager");
var _OctaviComponent = require("./OctaviComponent.widget");
var _OctaviParameters = _interopRequireDefault(require("../../../services/ui/OctaviParameters"));
var _utils = require("../../../services/ui/utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const weekDayStrByIsoWeekDay = {
  // from sql
  '1': 'monday',
  '2': 'tuesday',
  '3': 'wednesday',
  '4': 'thursday',
  '5': 'friday',
  '6': 'saturday',
  '7': 'sunday'
};
class PeriodCountWidget extends _react.default.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "getDataType", () => {
      return this.props.period === 'dow' ? 'totalCountPerWeekday' : this.props.period === 'hour' ? 'totalCountPerHour' : undefined;
    });
    (0, _defineProperty2.default)(this, "clearValueFilter", filterName => {
      const dataType = this.getDataType();
      const widgetOptions = _OctaviParameters.default.get(`selectedWidgets.${this.props.parentUuid}.options`, {});
      const filterKey = (0, _localStorageManager.getLocalStorageKey)(this.state.filters, filterName, widgetOptions);
      (0, _localStorageManager.clearLocalStorageForFilter)(filterKey, this.props.object, dataType);
    });
    (0, _defineProperty2.default)(this, "onRefreshClick", () => {
      // Make sure to reset the data in the local storage before
      this.clearValueFilter('FilterOne');
      if (_OctaviParameters.default.comparisonIsSelected) {
        this.clearValueFilter('FilterTwo');
      }

      // Reset the values to load again
      this.setState({
        value0: null,
        value1: null
      }, () => {
        this.updateTimeRange();
      });
    });
    (0, _defineProperty2.default)(this, "getNumberOfActivities", (value, item) => value && value.status === 'success' ? value[item] || 0 : value && value.status === 'no_data' ? 'no_data' : Number.NaN);
    this.state = {
      widgetOptions: (_OctaviParameters.default.selectedWidgets[this.props.parentUuid] || {}).options || {},
      comparisonIsSelected: _OctaviParameters.default.get('comparisonIsSelected', false),
      // TODO Not an array because each value is updated independently. This avoids state update race condition. But each filter's data should be in its own widget, with its own state
      value0: null,
      value1: null,
      filters: _OctaviParameters.default.filters
    };
    this.updateTimeRange = this.updateTimeRange.bind(this);
    this.updateComparisonSelection = this.updateComparisonSelection.bind(this);
    this.updateWidgetOptions = this.updateWidgetOptions.bind(this);
    this.onDownloadClick = this.onDownloadClick.bind(this);
  }
  componentDidMount() {
    //connect to filter modification
    _ServiceLocator.default.eventManager.on('taxi.filter.submit', this.updateTimeRange);
    //connect widget to comparision
    _ServiceLocator.default.eventManager.on('taxi.filter.comparisonIsSelected.update', this.updateComparisonSelection);
    //connect widget to options
    _ServiceLocator.default.eventManager.on(`taxi.widget.${this.props.parentUuid}SelectOptions.update`, this.updateWidgetOptions);
    this.updateTimeRange();
  }
  componentWillUnmount() {
    _ServiceLocator.default.eventManager.off('taxi.filter.submit', this.updateTimeRange);
    _ServiceLocator.default.eventManager.off('taxi.filter.comparisonIsSelected.update', this.updateComparisonSelection);
    _ServiceLocator.default.eventManager.off(`taxi.widget.${this.props.parentUuid}SelectOptions.update`, this.updateWidgetOptions);
  }
  updateComparisonSelection() {
    this.setState({
      comparisonIsSelected: _OctaviParameters.default.comparisonIsSelected
    });
    this.updateTimeRange();
  }
  updateWidgetOptions() {
    this.setState({
      widgetOptions: _OctaviParameters.default.selectedWidgets[this.props.parentUuid].options
    });
    this.updateTimeRange();
  }
  updateValueFilter(filterName) {
    const filterIdx = (0, _utils.getFilterIdx)(this.state.filters, filterName);
    const widgetOptions = _OctaviParameters.default.get(`selectedWidgets.${this.props.parentUuid}.options`, {});
    const filterKey = (0, _localStorageManager.getLocalStorageKey)(this.state.filters, filterName, widgetOptions);
    const dataType = this.getDataType();
    const result = (0, _localStorageManager.loadLocalStorageFromFilter)(filterKey, this.props.object, dataType);
    // data already existing in locale storage
    if (result) {
      this.setState({
        [`value${filterIdx}`]: result
      });
    }
    // data doesn't exist in locale storage, need to import and compute data
    else {
      const dates = (0, _utils.getDatesForPeriodAggregation)(this.state.filters[filterIdx]['calendarStartAt'], this.state.filters[filterIdx]['calendarEndAt'], widgetOptions.temporalOption);
      const startAt = dates['periodStart'].tz('utc').unix();
      const endAt = dates['periodEnd'].tz('utc').unix();
      let queryType;
      switch (this.props.period) {
        case "dow":
          queryType = "byWeekday";
          break;
        case "hour":
          queryType = "byHour";
          break;
      }
      _ServiceLocator.default.socketEventManager.emit(`taxi.count.${queryType}.timeRange`, {
        object: this.props.object,
        customFilterString: this.props.customFilterString ? this.props.customFilterString : "",
        dataSourceIds: _OctaviParameters.default.dataSourceIds,
        startAt: startAt,
        endAt: endAt,
        filters: (0, _utils.buildWidgetFilter)(this.state.filters, filterName, this.props.object, widgetOptions),
        type: this.props.type,
        widgetSpecs: this.props.widgetSpecs
      }, function (responseStatus) {
        let result;
        if (Status.isStatusOk(responseStatus)) {
          const response = Status.unwrap(responseStatus);
          result = _objectSpread({
            status: response.status
          }, response.counts);
          (0, _localStorageManager.saveLocalStorageDataFromFilter)(filterKey, this.props.object, result, dataType);
        } else {
          // error status
          result = {
            status: 'error'
          };
        }
        this.setState({
          [`value${filterIdx}`]: result
        });
      }.bind(this));
    }
  }
  updateTimeRange() {
    const newFilters = _OctaviParameters.default.filters;
    const idxFilterOne = (0, _utils.getFilterIdx)(newFilters, 'FilterOne');
    const idxFilterTwo = (0, _utils.getFilterIdx)(newFilters, 'FilterTwo');

    //we only updqte filters if dates are not null
    if (newFilters[idxFilterOne]['calendarStartAt'] && newFilters[idxFilterOne]['calendarEndAt']) {
      // we start by init value to null to relaunch loading page
      this.setState({
        value0: null,
        value1: null,
        filters: newFilters
      }, function () {
        this.updateValueFilter("FilterOne");
        if (_OctaviParameters.default.comparisonIsSelected && this.state.filters[idxFilterTwo]['calendarStartAt'] && this.state.filters[idxFilterTwo]['calendarEndAt']) {
          this.updateValueFilter("FilterTwo");
        }
      }.bind(this));
    }
  }
  onDownloadClick(data) {
    (0, _utils.exportTocsv)(`${this.props.fileName}.csv`, data);
  }
  render() {
    const idxFilterOne = (0, _utils.getFilterIdx)(this.state.filters, 'FilterOne');
    const idxFilterTwo = (0, _utils.getFilterIdx)(this.state.filters, 'FilterTwo');
    if ((0, _LodashExtensions._isBlank)(this.state[`value${idxFilterOne}`]) || this.state.comparisonIsSelected == true && ((0, _LodashExtensions._isBlank)(this.state[`value${idxFilterOne}`]) || (0, _LodashExtensions._isBlank)(this.state[`value${idxFilterTwo}`]))) {
      return /*#__PURE__*/_react.default.createElement(_pages.LoadingPage, null);
    }

    //periods count is used to render table and periods data is passed to csv downloader
    const periodCount = [];
    const periodData = [];
    let fileExportName;
    switch (this.props.period) {
      case "dow":
        fileExportName = "weekDay";
        break;
      case "hour":
        fileExportName = "hour";
        break;
    }
    if (this.state.comparisonIsSelected) {
      periodCount.push(/*#__PURE__*/_react.default.createElement("tr", {
        key: "init"
      }, /*#__PURE__*/_react.default.createElement("th", null), /*#__PURE__*/_react.default.createElement("td", null, "P 1"), /*#__PURE__*/_react.default.createElement("td", {
        className: "right"
      }, "P 2")));
      periodData.push([this.props.t(`octavi:filesExport:${fileExportName}`), 'value p 1', 'value p 2']);
    } else {
      periodData.push([this.props.t(`octavi:filesExport:${fileExportName}`), 'value']);
    }
    let iterator;
    switch (this.props.period) {
      case "dow":
        iterator = weekDayStrByIsoWeekDay;
        break;
      case "hour":
        iterator = (0, _toConsumableArray2.default)(Array(24).keys());
        break;
    }
    let itemTextFonction;
    switch (this.props.period) {
      case "dow":
        itemTextFonction = function (_item) {
          return this.props.t(`main:dateTime:weekdays:${weekDayStrByIsoWeekDay[_item]}`);
        }.bind(this);
        break;
      case "hour":
        itemTextFonction = function (_item) {
          return `${_item}:00${this.props.t("main:rangeTo")}${_item}:59`;
        }.bind(this);
        break;
    }
    for (const item in iterator) {
      periodCount.push(/*#__PURE__*/_react.default.createElement("tr", {
        key: item
      }, /*#__PURE__*/_react.default.createElement("th", {
        className: "right",
        style: {
          paddingRight: "10px"
        }
      }, itemTextFonction(item)), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_OctaviComponent.OctaviFilterResult, {
        value: this.getNumberOfActivities(this.state[`value${idxFilterOne}`], item.toString())
      })), this.state.comparisonIsSelected && /*#__PURE__*/_react.default.createElement("td", {
        className: "right _left_border"
      }, /*#__PURE__*/_react.default.createElement(_OctaviComponent.OctaviFilterResult, {
        value: this.getNumberOfActivities(this.state[`value${idxFilterTwo}`], item.toString())
      }))));
      if (this.state.comparisonIsSelected) {
        periodData.push([itemTextFonction(item), this.getNumberOfActivities(this.state[`value${idxFilterOne}`], item.toString()), this.getNumberOfActivities(this.state[`value${idxFilterTwo}`], item.toString())]);
      } else {
        periodData.push([itemTextFonction(item), this.getNumberOfActivities(this.state[`value${idxFilterOne}`], item.toString())]);
      }
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "tr__widget__container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "tr__widget__header"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "widget_title_width"
    }, /*#__PURE__*/_react.default.createElement("h3", null, this.props.title)), /*#__PURE__*/_react.default.createElement("div", {
      className: "widget_button_width"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "transparent",
      type: "button",
      onClick: () => this.onDownloadClick(periodData)
    }, /*#__PURE__*/_react.default.createElement("img", {
      className: `_icon chart_line_white`,
      src: "/dist/images/icons/octavi/export_to_file_white.svg",
      alt: "settings"
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "widget_button_width"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "transparent",
      type: "button",
      onClick: () => this.onRefreshClick()
    }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _faSync.faSync,
      className: 'icon_white'
    })))), /*#__PURE__*/_react.default.createElement("table", {
      style: {
        "borderSpacing": 0,
        width: "100%"
      }
    }, /*#__PURE__*/_react.default.createElement("tbody", null, periodCount)), !(0, _LodashExtensions._isBlank)(this.props.subtitle) && /*#__PURE__*/_react.default.createElement("p", {
      className: "tr__widget__big-value-subtitle"
    }, this.props.subtitle));
  }
}
exports.default = PeriodCountWidget;